// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"c6274821","124":"6c39f774","196":"ae137cf6","210":"5fc8d877","533":"90dae3f9","546":"1023e010","626":"c9be825e"}[chunkId] + ".chunk.css";
};